var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.componentsCache}},[(_vm.isRouterAlive)?_c('router-view',{key:_vm.routerViewKey+'',on:{"hook:mounted":function($event){return _vm.changeRouteCache()}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }